import React, { useState } from 'react';
import MainNav from '@/v3-dashboard/components/MainNav';
import ChatbotSidebar from '@/v3-dashboard/components/ChatbotSidebar';
import TeamManagementDropdown from '@/v3-dashboard/components/TeamManagementDropdown';
import RunningJobsDropdown from '@/v3-dashboard/components/RunningJobsDropdown';
import { useParams, useNavigate } from 'react-router-dom';
import { useChatbotStore } from '@/stores/chatbot/chatbotStore';
import Button from '@/shared/components/UI/Button';
import LeftArrowIcon from '@/shared/icons/LeftArrowIcon';
import DChatbotSidebar from '@/components/Chatbot/Details/ChatbotSidebar';

const MobileNavDrawer = ({ isOpen, onClose }) => {
  const params = useParams();
  const navigate = useNavigate();
  const selectedChatbot = useChatbotStore((state) => state.selectedChatbot);
  const isChatbotDetailsPage = Boolean(params?.id);
  const hasChatbotSelected = Boolean((selectedChatbot?.kb_id || selectedChatbot?.knowledge_base?.id) && params?.id);

  // View state: 'main', 'team', 'chatbot'
  const [currentView, setCurrentView] = useState('main');

  if (!isOpen) return null;

  // Team Selection View - using TeamManagementDropdown with isMobileView
  if (currentView === 'team') {
    return (
      <TeamManagementDropdown
        isMobileView
        onBack={() => setCurrentView('main')}
        onClose={onClose}
      />
    );
  }

  // Chatbot Selection View - using RunningJobsDropdown with isMobileView
  if (currentView === 'chatbot') {
    return (
      <RunningJobsDropdown
        mode="per_user"
        isMobileView
        onBack={() => setCurrentView('main')}
        onClose={onClose}
      />
    );
  }

  // Main Navigation View
  return (
    <div className="md:hidden w-full h-full flex flex-col overflow-y-auto bg-v3-black-lightest">
      {/* Workspace Header - Show only when chatbot is selected */}
      {hasChatbotSelected && (
        <div className="px-v3-sm sm:px-v3-lg pt-[12px]">
          <Button
            icon={LeftArrowIcon}
            label="Workspace"
            onClick={() => navigate('/dashboard')}
            iconColor="!text-v3-purple-primary"
            className="w-full justify-start !text-v3-h10 !bg-transparent border-0 !h-[40px] !text-v3-purple-primary !px-0  md:ml-0"
          />
        </div>
      )}

      {/* Team and Chatbot Selection Section */}
      <div className="px-v3-sm pl-v3-lg md:pl-v3-sm pt-[12px] pb-v3-sm flex flex-col border-b border-v3-card-border">
        {/* Team Selection Button - reuses TeamManagementDropdown button UI */}
        <TeamManagementDropdown
          isMobileView
          isMobileButton
          onMobileButtonClick={() => setCurrentView('team')}
        />

        {/* Chatbot Selection Button - reuses RunningJobsDropdown button UI */}
        {hasChatbotSelected && (
          <RunningJobsDropdown
            mode="per_user"
            isMobileView
            isMobileButton
            onMobileButtonClick={() => setCurrentView('chatbot')}
          />
        )}
      </div>

      {/* Navigation Items */}
      <div className="flex-1">
        {isChatbotDetailsPage ? (
          // <ChatbotSidebar closeMobileNav={onClose} />
          <DChatbotSidebar closeMobileNav={onClose} />
        ) : (
          <MainNav closeMobileNav={onClose} />
        )}
      </div>
    </div>
  );
};

export default MobileNavDrawer;

